import React, { FC } from 'react'
import './index.scss'

export const Label: FC<any> = ({ children } : any) => (
    <label className="c-label">{ children }</label>
)
